import Route from "../../../router/Route";
import { RouterView } from "vue-router";

import HomeIndex from "../pages/HomeIndex.vue";

export default new Route("home", "/home", RouterView, [
	new Route("home.index", "", HomeIndex, []),
]);
